import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Banknote } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { RecordPayment } from "@/features/finance/components/record-payment";

function FinancePaymentsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <PageHeader title={t(msg`Payments`)} backTo="/finance" icon={Banknote} />
      <div class="mt-4">
        <RecordPayment />
      </div>
    </PageContainer>
  );
}

export const financePaymentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/payments",
  component: withFeatureGate("billing.core", FinancePaymentsPage),
});
